import { basicInitialState } from 'store/_utils/basicInitialState';
import { TFarmsState } from './farmsModel';

export const farmsInitialState: TFarmsState = {
  ...basicInitialState,
  farms: []
};
